import theme from '../Theme';

const styles = (materialTheme) => ({
  deliveryOptionsButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: `1px solid ${materialTheme.palette.secondary.dark}`,
    borderRadius: '24px',
    width: '250px',
  },
  messageColor: {
    backgroundColor: theme.colors.white120,
    borderRadius: 4,
    height: 30,
    color: theme.colors.red10,
    display: 'flex',
    padding: '7px 0px',
  },
  selectedOptionBackground: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: `1px solid ${theme.colors.white12}`,
    borderRadius: '24px',
    width: '250px',
    backgroundColor: theme.colors.blueBackground,
  },
  deliveryButtonsGap: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.screenSize.mobile]: {
      display: 'none',
    },
  },
  selectOption: {
    display: 'none',
    [theme.screenSize.mobile]: {
      display: 'flex',
    },
  },
  driverInstruction: {
    marginTop: '5px !important',
    fontSize: '13px',
  },
  textFieldParent: {
    padding: '20px',
    backgroundColor: theme.colors.blueBackground,
    color: materialTheme.palette.primary.dark,
    borderRadius: '8px',
  },
  innerTextFieldParent: {
    backgroundColor: materialTheme.palette.primary.contrastText,
  },
  iconBackground: {
    background: 'white',
    color: 'black',
  },
  locationMargin: {
    marginTop: '20px',
    marginBottom: '2px',
  },
  addressMargin: {
    marginBottom: '2px',
  },
  buildingAddressWidth: {
    width: '50%',
    [theme.screenSize.middleWidth]: {
      width: '100%',
    },
  },
  addressText: {
    marginBottom: '10px',
  },
  optionImageMargin: {
    marginRight: '10px',
    marginBottom: '3px',
    marginTop: '2px',
  },
  parentNoteBox: {
    display: 'flex',
  },
  avatarColor: {
    width: '24px',
    height: '24px',
  },
});

export default styles;
